import { z } from 'zod';

import { InstagramCreatorGender } from '@frontend/gql/social/graphql';

export const INSTAGRAM_CREATOR_GENDER = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  CUSTOM: 'CUSTOM',
  UNKNOWN: 'UNKNOWN',
} as const satisfies Record<string, InstagramCreatorGender>;

export const InstagramCreatorGenderSchema = z.nativeEnum(INSTAGRAM_CREATOR_GENDER);
